module.exports = __webpack_public_path__ + "8ec67baa5c368b32e28f5c03e50a7b6f.svg";